'use client';
import React, { useEffect, useRef, useState } from 'react';
import { useModal, MODAL_TYPES } from './ModalProvider';

export default function HeroContentModalWrapper({
  isOpen,
  onClose,
  content,
  title = 'Information'
}) {
  const modalRef = useRef(null);
  const [needsPadding, setNeedsPadding] = useState(false);
  const { modalUtils, getCloseButton } = useModal();

  useEffect(() => {
    if (isOpen) {
      document?.querySelector(`.hero-content`)?.classList.remove('z-30');
      document?.querySelector(`.hero-content`)?.classList.add('z-10');

      if (modalRef.current) {
        modalRef.current.focus();
        // Ensure modal content starts at the top
        modalRef.current.scrollTop = 0;
      }
    } else {
      document?.querySelector(`.hero-content`)?.classList.remove('z-10');
      document?.querySelector(`.hero-content`)?.classList.remove('z-30');
    }

    return () => {
      // Reset hero content z-index on cleanup
      document?.querySelector(`.hero-content`)?.classList.remove('z-10');
      document?.querySelector(`.hero-content`)?.classList.remove('z-30');
    };
  }, [isOpen]);

  // Ensure modal scrolls to top when opened and check if padding is needed
  useEffect(() => {
    if (isOpen && modalRef.current) {
      // Find the modal container with overflow-auto
      const modalContainer = modalRef.current.closest('.overflow-auto');
      if (modalContainer) {
        modalContainer.scrollTop = 0;

        // Check if content height fills the window height
        const containerHeight = modalContainer.offsetHeight;
        const scrollHeight = modalContainer.scrollHeight;

        // If content is scrollable (fills the window), add padding
        setNeedsPadding(scrollHeight > containerHeight);
      }
      // Also ensure the modal body itself is at top
      modalRef.current.scrollTop = 0;
    }
  }, [isOpen, content]);

  if (!isOpen) return null;

  return modalUtils.createModalWrapper({
    modalType: MODAL_TYPES.heroContent,
    isOpen,
    onClose,
    containerClassName: modalUtils.containerPresets.standard.basic,
    children: (
      <div ref={modalRef} tabIndex={-1} className={needsPadding ? 'p-4' : ''}>
        {getCloseButton(MODAL_TYPES.heroContent, onClose)}

        {title && (
          <h2 id="modal-title" className="sr-only">
            {title}
          </h2>
        )}

        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    )
  });
}
